import PropTypes from 'prop-types';
import { vars } from '@etg/wings';
import { m as motion } from 'framer-motion';
import { css, cx, etiColors, mediaQueries } from '@eti/styles';
import { useTranslation } from '@eti/providers';
import ManulifeStepTitle from './ManulifeStepTitle';
import ManulifeProvince from './ManulifeProvince';
import ManulifeTravelers from './ManulifeTravelers';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const wrapperStyles = active => css`
  background-color: #fff;
  border-bottom-left-radius: ${vars.card.borderRadius};
  border-bottom-right-radius: ${vars.card.borderRadius};
  border-top: 1px solid #e5e5e5;
  position: relative;
  visibility: ${active ? 'visible' : 'hidden'};
`;
const contentWrapperStyles = css`
  position: relative;
`;
const stepsBorderStyles = css`
  background-color: ${etiColors.grayScale[6]};
  height: calc(100% - 112px);
  left: 26px;
  position: absolute;
  top: 48px;
  width: 1px;

  [dir='rtl'] & {
    left: auto;
    right: 26px;
  }

  @media ${mediaQueries.medium.up} {
    height: calc(100% - 94px);
  }
`;
const motionVariants = {
  visible: {
    opacity: 1,
    height: 'auto',
    transition: {
      type: 'tween',
      duration: 0.3
    }
  },
  hidden: {
    opacity: 0,
    height: 0,
    transition: {
      type: 'tween',
      duration: 0.2
    }
  }
};
const manulifeContentWrapperStyles = active => css`
  overflow-y: ${active ? 'visible' : 'hidden'};
`;
const travelersTitleWrapperStyles = active => css`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  opacity: ${active ? 1 : 0.5};

  @media ${mediaQueries.medium.up} {
    align-items: center;
    flex-direction: row;
  }
`;
const travelersTextStyles = css`
  color: ${etiColors.grayScale[10]};
  font-size: 0.75rem;
  margin-left: 35px;

  [dir='rtl'] & {
    margin-left: 0;
    margin-right: 35px;
  }
`;
const contentWrapperPaddingStyles = css`
  padding: 15px;
`;
const ManulifeContent = _ref => {
  let {
    isActive,
    className,
    dateFormat,
    form,
    onFetchPrice,
    productName,
    shouldShowTravelers,
    travelers,
    provinces
  } = _ref;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/_jsx(motion.div, {
    animate: isActive ? 'visible' : 'hidden',
    className: manulifeContentWrapperStyles(isActive),
    "data-testid": `${productName}-content`,
    variants: motionVariants,
    children: /*#__PURE__*/_jsxs("div", {
      className: cx(wrapperStyles(isActive), className),
      children: [/*#__PURE__*/_jsxs("div", {
        className: cx(contentWrapperStyles, contentWrapperPaddingStyles),
        children: [/*#__PURE__*/_jsx("span", {
          className: stepsBorderStyles
        }), /*#__PURE__*/_jsx(ManulifeStepTitle, {
          active: isActive,
          step: "1",
          text: t('Manulife.Province.Title')
        }), /*#__PURE__*/_jsx(ManulifeProvince, {
          options: provinces,
          productName: productName
        }), /*#__PURE__*/_jsxs("div", {
          className: travelersTitleWrapperStyles(shouldShowTravelers),
          children: [/*#__PURE__*/_jsx(ManulifeStepTitle, {
            isActive: shouldShowTravelers,
            step: "2",
            text: t('Manulife.Travelers.Title')
          }), /*#__PURE__*/_jsx("span", {
            className: travelersTextStyles,
            children: t('Manulife.Travelers.Price.Text')
          })]
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: contentWrapperStyles,
        children: /*#__PURE__*/_jsx(ManulifeTravelers, {
          dateFormat: dateFormat,
          form: form,
          isActive: shouldShowTravelers,
          onFetchPrice: onFetchPrice,
          productName: productName,
          travelers: travelers
        })
      })]
    })
  });
};
ManulifeContent.propTypes = {
  className: PropTypes.string,
  dateFormat: PropTypes.string,
  form: PropTypes.string,
  isActive: PropTypes.bool,
  onFetchPrice: PropTypes.func.isRequired,
  productName: PropTypes.string,
  provinces: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string
  })),
  shouldShowTravelers: PropTypes.bool,
  travelers: PropTypes.arrayOf(PropTypes.shape({
    ageType: PropTypes.string,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string
  }))
};
export default ManulifeContent;
//# sourceMappingURL=ManulifeContent.js.map